import { render } from "./PaneFoot.vue?vue&type=template&id=79a02397&scoped=true"
import script from "./PaneFoot.vue?vue&type=script&lang=js"
export * from "./PaneFoot.vue?vue&type=script&lang=js"

import "./PaneFoot.vue?vue&type=style&index=0&id=79a02397&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a02397"]])

export default __exports__